import { defaultIconColor } from 'assets/constants';
import { SVGComponentPropsType } from 'assets/types';
import { CURRENCY_DEFAULT_SIZE } from './constants';

const defaultSize = CURRENCY_DEFAULT_SIZE;

export default ({
  height = defaultSize,
  width = defaultSize,
  color = defaultIconColor,
  opacity = 1,
  outlined = false,
  viewBox = `0 0 ${defaultSize} ${defaultSize}`,
  ...props
}: SVGComponentPropsType) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" {...props}>
    <g stroke={color} opacity={opacity} strokeWidth="2">
      {outlined && <circle cx="12" cy="12" r="11" />}
      <path d="M16 9c0-1.65685-1.34315-3-3-3h-1.53333C9.55208 6 8 7.55208 8 9.46667v4.06666C8 15.4479 9.55208 17 11.46667 17H13c1.65685 0 3-1.3431 3-3" />
      <path d="M13 10H6m7 3H6" />
    </g>
  </svg>
);
